import utm from './utm';
import errorHandler from '../errorHandler';
import httpRequest from '../httpRequest';

export const sendToHubspot = async (data) => {
  const UTM = utm.getAll();
  const hasUTM = Object.keys(UTM).length > 0;

  const hubspotPayload = {
    fields: [
      {
        name: 'full_name',
        value: data.fullName ? data.fullName : ''
      },
      {
        name: 'number_of_employees',
        value: data.number_of_employees ? data.number_of_employees : ''
      },
      {
        name: 'phone',
        value: data.phoneNumber
      },
      {
        name: 'company',
        value: data.company
      },
      {
        name: 'email',
        value: data.email
      },
      {
        name: 'category',
        value: data.category
      },
      {
        name: 'utm_source',
        value: hasUTM && Object.keys(UTM.utm_source) ? UTM.utm_source : ''
      },
      {
        name: 'utm_campaign',
        value: hasUTM && Object.keys(UTM.utm_campaign) ? UTM.utm_campaign : ''
      },
      {
        name: 'utm_medium',
        value: hasUTM && Object.keys(UTM.utm_medium) ? UTM.utm_medium : ''
      },
      {
        name: 'utm_content',
        value: hasUTM && Object.keys(UTM.utm_content) ? UTM.utm_content : ''
      }
    ],
    context: {
      pageUri: `https://lifepal.tech/${window.location.pathname}`,
      pageName: 'Lifepal Asuransi'
    }
  };

  const hubspotRequest = {
    method: 'POST',
    body: JSON.stringify(hubspotPayload)
  };

  try {
    const res = await httpRequest(
      'https://api.hsforms.com/submissions/v3/integration/submit/5626172/356ef7d3-61af-471e-b8e4-bca22d6ddac8',
      hubspotRequest
    );
    return res;
  } catch (err) {
    const res = errorHandler(err);
    return res;
  }
};
